<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="12" class="text-center text-sm-left flex-header">
                <h3 class="page-title">Nowa pozycja w słowniku</h3>
                <d-button theme="secondary" @click.prevent="$router.push({name: 'dictionary'})"><i class="material-icons">keyboard_backspace</i> Wróć do listy</d-button>
                <d-button theme="success" @click.prevent="submitForm"><i class="material-icons">add</i> Dodaj do słownika</d-button>
            </d-col>
        </d-row>
        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card class="card-small" v-if="fetched">

                <d-list-group flush @keyup.enter="submitForm">
                    <d-list-group-item class="p-3">
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.rzeczownik" name="rzeczownik" label="Rzeczownik" placeholder="pożyczka"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.mianownik" name="mianownik" label="Mianownik (Kto? Co?)" placeholder="pożyczka"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.dopelniacz" name="dopelniacz" label="Dopełniacz (Kogo? Czego?)" placeholder="pożyczki"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.celownik" name="celownik" label="Celownik (Komu? Czemu?)" placeholder="pożyczce"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.biernik" name="biernik" label="Biernik (Kogo? Co?)" placeholder="pożyczkę"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.narzednik" name="narzednik" label="Narzędnik (Z kim? Z czym?)" placeholder="pożyczką"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.miejscownik" name="miejscownik" label="Miejscownik (O kim? O czym?)" placeholder="pożyczce"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.wolacz" name="wolacz" label="Hej!" placeholder="pożyczko"></ss-input>
                            </d-col>
                        </d-row>
                    </d-list-group-item>
                </d-list-group>
            </d-card>
        </transition>
    </d-container>
</template>

<script>
    import LarErrors from '../helpers/Errors';

    export default {
        name: "DictionarytNew",
        components: {
            LarErrors,
        },
        data(){
            return{
                fetched: false,
                lar_errors: LarErrors,
                submitting: false,
                dictionary: {
                    rzeczownik:     '',
                    mianownik:      '',
                    dopelniacz:     '',
                    celownik:       '',
                    biernik:        '',
                    narzednik:      '',
                    miejscownik:    '',
                    wolacz:         '',
                },
            }
        },
        methods: {
            submitForm(){
                this.submitting = true;
                axios.post('api/dictionary/store', this.dictionary).then(response => {
                    Vue.swal({
                        type: 'success',
                        title: 'Pozycja została dodana do słownika.',
                        showConfirmButton: true,
                    }).then(() => {
                        this.$router.push({name: 'dictionary-edit', params: {id: response.data.item.id}});
                    });
                    this.submitting = false;
                }).catch((error) =>{

                    this.submitting = false;
                    console.log(error);
                    LarErrors.record(error.response.data.errors)
                })
            }
        },
        mounted(){
            // this.fetchData();
            this.fetched = true;
        },
    }
</script>
